/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useContext } from "react";
import { User } from "@auth0/auth0-spa-js";
import Auth0Context, { Auth0ContextInterface } from "./auth0-context";

/**
 * ```js
 * const {
 *   // Auth state:
 *   error,
 *   isAuthenticated,
 *   isLoading,
 *   user,
 *   // Auth methods:
 *   getAccessTokenSilently,
 *   getIdTokenClaims,
 *   loginWithRedirect,
 *   logout,
 * } = useAuth0<TUser>();
 * ```
 *
 * Use the `useAuth0` hook in your components to access the auth state and methods.
 *
 * TUser is an optional type param to provide a type to the `user` field.
 */
const useAuth0 = <TUser extends User = User>(): Auth0ContextInterface<TUser> =>
  useContext(Auth0Context) as Auth0ContextInterface<TUser>;

export default useAuth0;
